import { makeAutoObservable } from 'mobx';

import { getSettings } from 'framework/userSettings';
import { Theme, ThemeUserSettings } from './types';

class ThemeStoreInner {
	private settings: ThemeUserSettings | null = null;

	constructor() {
		makeAutoObservable<ThemeStoreInner, 'loading'>(this, { loading: false });
	}

	get theme() {
		return this.settings?.theme ?? Theme.Light;
	}

	async init() {
		const { data } = await getSettings<ThemeUserSettings>('Theme');
		this.settings = data;
	}

	setTheme(theme: Theme) {
		if (this.settings != null) {
			this.settings.theme = theme;
		}
	}

	toggle = () => {
		this.setTheme(this.theme == Theme.Dark ? Theme.Light : Theme.Dark);
	};
}

export const ThemeStore = new ThemeStoreInner();
